
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiForward as ObiForwardElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-forward.js';
 
 
 

 
 export const ObiForward = createComponent({
   react: React,
   tagName: 'obi-forward',
   elementClass: ObiForwardElement,
   events: {
     
   }
  });
 
 